module.exports = __webpack_public_path__ + "static/media/3.e1c30d1d.jpg";